import React, { useEffect } from 'react'

import '../css/style.min.css'

import Header from './Header'
import Footer from './Footer'

const Layout = ({ children }) => {

	useEffect(() => {

		const topNav = window.document.querySelector('.topNav');
		const main = window.document.querySelector('.main');

		const handleHeightChange = (h) => {
			main.style.marginTop = h;
		}

		const resize_ob = new ResizeObserver(function (entries) {
			// since we are observing only a single element, so we access the first element in entries array
			let rect = entries[0].contentRect;
			// current height
			let width = rect.width;
			let height = rect.height;
			if (width > 968) {
				handleHeightChange(`${height}px`);
			} else {
				handleHeightChange(`8rem`);
			}
		});

		// start observing for resize
		resize_ob.observe(topNav);

		// ---------------------------------------

		const fz_sm = window.document.getElementById('fz_sm')
		const fz = window.document.getElementById('fz')
		const fz_lg = window.document.getElementById('fz_lg')

		const r = document.querySelector(':root');
		const originalFz = 17;
		const scale = 0.75;

		let fzConfig = {
			fz: originalFz,
			MAX_STEP: 3,
			currentMaxStep: 0,
			currentMinStep: 0
		}

		const prevFzConfig = window.localStorage.getItem('__fzConfig');
		if (!prevFzConfig) { window.localStorage.setItem('__fzConfig', JSON.stringify(fzConfig)) }

		fzConfig = prevFzConfig ? JSON.parse(prevFzConfig) : fzConfig;
		r.style.setProperty('--default-fz', fzConfig.fz + 'px');

		fz_sm.addEventListener('click', () => {
			if (fzConfig.currentMaxStep > 0) {
				// decrease
				fzConfig.fz -= scale
				r.style.setProperty('--default-fz', fzConfig.fz + 'px');
				fzConfig.currentMaxStep -= 1

			}
			else if (fzConfig.currentMinStep < fzConfig.MAX_STEP) {
				// decrease
				fzConfig.fz -= scale
				r.style.setProperty('--default-fz', fzConfig.fz + 'px');
				fzConfig.currentMinStep += 1
			}
			window.localStorage.setItem('__fzConfig', JSON.stringify(fzConfig));
		});

		fz.addEventListener('click', () => {
			fzConfig.fz = originalFz
			r.style.setProperty('--default-fz', fzConfig.fz + 'px');
			fzConfig.currentMaxStep = 0
			fzConfig.currentMinStep = 0
			window.localStorage.setItem('__fzConfig', JSON.stringify(fzConfig));
		});

		fz_lg.addEventListener('click', () => {
			if (fzConfig.currentMinStep > 0) {
				// increase
				fzConfig.fz += scale
				r.style.setProperty('--default-fz', fzConfig.fz + 'px');
				fzConfig.currentMinStep -= 1

			}
			else if (fzConfig.currentMaxStep < fzConfig.MAX_STEP) {
				// decrease
				fzConfig.fz += scale
				r.style.setProperty('--default-fz', fzConfig.fz + 'px');
				fzConfig.currentMaxStep += 1
			}
			window.localStorage.setItem('__fzConfig', JSON.stringify(fzConfig));
		});

		// -------------------------------------------


		return () => {
			resize_ob.unobserve(topNav);
		}
	}, [])

	return (
		<>
			{/* <Helmet>
				<script src="/js/main.js" defer></script>
			</Helmet> */}
			<Header />
			<main className="main">
				{children}
			</main>
			<Footer />
		</>
	)
}

export default Layout
